import { formatPrice } from './formatPrice.ts';
import { discountLine } from './membershipPrice.ts';

/**
 * Monthly Coaching's three price lines, as the spec approves them (batch
 * 3), on the checkout and on the offer sheet in a call (batch 5).
 */
export function monthlyCoachingPriceLines(priceCents: number, coachFirstName: string): string[] {
  return [
    'Billed monthly from the day of your first lesson. Today covers your first month.',
    `Your price stays ${formatPrice(priceCents)} even if ${coachFirstName}'s prices increase.`,
    'Not the right fit after lesson one? Full refund, any time before your second.',
  ];
}

/**
 * Monthly Coaching's terms as the checkout shows them: the discount, the
 * three lines and the spots left. The offer sheet in a call shows the same,
 * word for word. No spots line when the coach set no limit or is full.
 */
export function monthlyCoachingTerms(
  priceCents: number,
  coachFirstName: string,
  summary: { singlePriceCents?: number | null; spotsLeft?: number | null } | null,
): { discount: string | null; lines: string[]; spots: string | null } {
  const left = summary?.spotsLeft ?? null;
  return {
    discount: discountLine(summary?.singlePriceCents, priceCents),
    lines: monthlyCoachingPriceLines(priceCents, coachFirstName),
    spots: left != null && left > 0 ? `${left} ${left === 1 ? 'spot' : 'spots'} left with ${coachFirstName}` : null,
  };
}

/** The Monthly Coaching page's footnote under Up next (Ryan, 28 Oct): one line. */
export const MONTH_CHANGE_LINE = 'Change any time up to 10 hours before.';
